import { Loader2, Send } from 'lucide-react';

export function ChatComposerActions({ selectedKB, loading, input, hasSelectedModel }) {
  const isDisabled = !selectedKB || loading || !input.trim() || !hasSelectedModel;

  return (
    <div className="flex items-center justify-between gap-4">
      <p className="text-xs text-zinc-600">
        Appuyez sur Entrée pour envoyer, Shift + Entrée pour une nouvelle ligne
      </p>
      <button
        type="submit"
        data-testid="send-button"
        disabled={isDisabled}
        className="flex h-11 items-center gap-2 rounded-sm bg-white px-6 font-medium text-black transition-all duration-300 hover:bg-zinc-200 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {loading ? (
          <>
            <Loader2 className="h-5 w-5 animate-spin" />
            <span>Envoi...</span>
          </>
        ) : (
          <>
            <span>Envoyer</span>
            <Send className="h-4 w-4" />
          </>
        )}
      </button>
    </div>
  );
}
